import { Star } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import type { Task } from "@/lib/db";
import { MustWinLimitError, setMustWin } from "@/lib/planner";
import { cn } from "@/lib/utils";

/** Pins or unpins one of the day's three must-wins (PL-3). */
export function MustWinStar({ task, day, full }: { task: Task; day: string; full: boolean }) {
	const pinned = task.must_win_date === day;
	async function toggle() {
		try {
			await setMustWin(task.id, day, !pinned);
		} catch (err) {
			if (err instanceof MustWinLimitError) toast.info("Three must-wins already. Unpin one first.");
			else toast.error("Could not save on this device. Try again.");
		}
	}
	return (
		<Button
			variant="ghost"
			size="icon"
			className="size-11 md:size-9"
			aria-label={`${pinned ? "Unpin must-win" : "Make must-win"}: ${task.title}`}
			aria-pressed={pinned}
			title={pinned ? "Unpin" : full ? "Three must-wins already" : "Make must-win"}
			onClick={toggle}
		>
			<Star className={cn(pinned && "fill-primary text-primary")} />
		</Button>
	);
}
